export const customStyles = {
  container: base => ({
    ...base,
    background: 'white',
    borderWidth: 0,
    border: '0px solid white',
    color: '#a8a8a8',
    borderColor: 'white',
    transition:
      'border-color 0.2s ease, box-shadow 0.2s ease, padding 0.2s ease',
    '&:hover': {
      boxShadow: '0 2px 4px 0 rgba(41, 56, 78, 0.1)',
    },
    flexGrow: 1,
    width: '100%',
  }),
  control: base => ({
    ...base,
    background: '#fcfcfc',
    color: '#a8a8a8',
    border: '1px solid #DBDDE0',
  }),
  input: base => ({
    ...base,
    height: '40px',
    marginTop: '-5px',
  }),
  valueContainer: base => ({
    ...base,
    background: '#fcfcfc',
    color: '#a8a8a8',
    height: '40px',
    borderRadius: '4px',
  }),
  singleValue: base => ({
    ...base,
    height: '45px',
    fontFamily: 'Avenir Next Airbo',
    fontSize: '18px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#5a5a5a',
    marginTop: '10px',
  }),
  option: (base, { isSelected }) => {
    return {
      ...base,
      height: '41px',
      borderRadius: '4px',
      fontFamily: 'Avenir Next Airbo',
      fontSize: '18px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      backgroundColor: isSelected ? 'rgba(216, 216, 216, 0.49)' : 'inherit',
      color: '#5a5a5a',
    };
  },
  dropdownIndicator: base => ({
    ...base,
  }),
  placeholder: base => ({
    fontFamily: 'Avenir Next Airbo',
    fontSize: '18px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#d8d8d8',
    marginLeft: '5px',
    marginTOp: '-5px',
  }),
  menu: base => ({
    ...base,
    marginTop: '0',
  }),
};

export const alertStyle = {
  display: 'inherit',
  width: '30vw',
  marginLeft: '-28vw',
  marginTop: '-250px',
  overflow: 'unset',
  left: '60%'
};
